import React from 'react';
import { Booking as BookingModel } from 'acscp/store';
import { Link } from 'react-router-dom';
import style from './booking.module.scss';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { editFlightRequest, repeatFlightRequest } from '../routeHelper';
import classNames from 'classnames';
import { getTranslatedViewItineraryString } from 'acscp/components/common/helpers/sharedViewItineraryText';

interface BookingButtonProps {
    booking: BookingModel;
    canPotentiallyRequestFlights: boolean;
}

const BookingButtonWithIntl: React.FunctionComponent<BookingButtonProps & InjectedIntlProps> =
({booking, canPotentiallyRequestFlights, intl}) => {
    if (booking.status === 'Flown' && !canPotentiallyRequestFlights) {
        return null;
    }

    let linkDestination: string;
    let linkclass: any;
    let buttonText: any;

    // Status-based customisations to the button.
    switch (booking.status) {
        case 'Enquiry':
            linkDestination = editFlightRequest(booking);
            linkclass = style.Link;
            buttonText = (
                <FormattedMessage
                    id={'components.bookings.booking.view'}
                    defaultMessage={'View'}
                />
            );
            break;

        case 'ItineraryAvailable':
            linkDestination = `/trip/${booking.id}`;
            linkclass = classNames(style.Link, style.LongTextLink);
            buttonText = getTranslatedViewItineraryString(intl.formatMessage);
            break;

        case 'Flown':
            linkDestination = repeatFlightRequest(booking);
            linkclass = classNames(style.Link, style.LongTextLink);
            buttonText = (
                <FormattedMessage
                    id={'components.bookings.booking.requestAgain'}
                    defaultMessage={'Request again'}
                />
            );
            break;

        default: // includes ('Flown' && canPotentiallyRequestFlights), amongst others.
            linkDestination = `/trip/${booking.id}`;
            linkclass = style.Link;
            buttonText = (
                <FormattedMessage
                    id={'components.bookings.booking.view'}
                    defaultMessage={'View'}
                />
            );
            break;
    }

    return (
        <Link
            to={linkDestination}
            className={linkclass}
        >
            {buttonText}
        </Link>
    );
};

export const BookingButton = injectIntl(BookingButtonWithIntl);
